if (!customElements.get('product-banner-media')) {
  customElements.define('product-banner-media', class extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.button = this.querySelector('.product-banner__video-toggle');
      if (!this.videos.length || !this.button) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.breakpoint = window.matchMedia('(max-width: 749px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;

      this.videos.forEach(video => {
        video.controls = false;
        for (const event of ['play', 'pause', 'ended']) {
          video.addEventListener(event, () => this.updateButton(), options);
        }
      });
      this.button.addEventListener('click', () => {
        if (!this.activeVideo) return;
        this.userPlayback = this.activeVideo.paused;
        this.syncPlayback();
      }, options);
      this.breakpoint.addEventListener('change', () => this.syncPlayback(), options);
      this.motion.addEventListener('change', () => this.syncPlayback(), options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);

      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.syncPlayback();
      });
      this.observer.observe(this);
      this.syncPlayback();
    }

    syncPlayback() {
      this.activeVideo = this.videos.find(video => getComputedStyle(video.parentElement).display !== 'none');
      const wantsPlayback = this.userPlayback ?? !this.motion.matches;
      this.videos.forEach(video => {
        if (video === this.activeVideo && this.visible && !document.hidden && wantsPlayback && this.isConnected) {
          if (video.paused) video.play().catch(() => this.updateButton());
        } else {
          video.pause();
        }
      });
      this.updateButton();
    }

    updateButton() {
      this.button.hidden = !this.activeVideo;
      if (!this.activeVideo) return;
      const playing = !this.activeVideo.paused && !this.activeVideo.ended;
      this.button.setAttribute('aria-controls', this.activeVideo.id);
      this.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      this.button.dataset.playing = String(playing);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.videos?.forEach(video => video.pause());
    }
  });
}
